import { Component, Input, OnChanges } from '@angular/core';
import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/app/environments/environment';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: [],
})
export class AppNavItemComponent implements OnChanges {
  @Input() item: NavItem | any;
  @Input() depth: any;
  @Input() onlyIcon?: boolean = false;


  constructor(public navService: NavService, public router: Router,
    public authService: AuthService,) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnChanges() {
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
      }
    });
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      if (item.href) {
        const targetUrl = (item.href in environment)
          ? (environment as any)[item.href]
          : item.href;

        window.open(targetUrl, '_blank');
      } else {
        this.router.navigate([item.route]);
      }
    }

    // scroll
    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0,
    });
  }

  hasPermission(permissions: string[]) {
    return this.authService.hasRole(permissions);
  }
}
